module.exports = __webpack_public_path__ + "img/senior-back-end-engineer.e5319516.jpg";